// storyboards.data.ts — GENERATED by agents/remy/slate-video/scripts/storyboard-data.mjs
// Do not hand-edit. Frames live on R2; every word here is real text so the UI
// can typeset it, rather than a picture of text baked into a JPEG.

export type SBShot = {
  id: string; size: string; angle: string; move: string;
  action: string; vo: string; text: string; sec: number; img: string;
};
export type SBEpisode = { slug: string; title: string; shots: SBShot[] };

export const FRAMES = "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/board/youtube/frames";

export const STORYBOARDS: SBEpisode[] = [
 {
  "slug": "e1-the-box",
  "title": "EP1 \u00b7 THE BOX \u2014 the man who gave away the world",
  "shots": [
   {
    "id": "1A",
    "size": "ECU",
    "angle": "eye",
    "move": "slow push",
    "action": "Corrugated steel wall fills frame. No context yet.",
    "vo": "This is the most boring object of the twentieth century.",
    "text": "",
    "sec": 7,
    "img": "e1-the-box-01.jpg"
   },
   {
    "id": "1B",
    "size": "WS",
    "angle": "high",
    "move": "static",
    "action": "Container yard to horizon. Thousands of identical boxes.",
    "vo": "There are around sixty million of them. And they are all, to the millimetre, the same.",
    "text": "60,000,000",
    "sec": 9,
    "img": "e1-the-box-02.jpg"
   },
   {
    "id": "1C",
    "size": "MS",
    "angle": "eye",
    "move": "pan",
    "action": "Boxes stacked on a ship, moving past camera.",
    "vo": "Same corner fittings. Same width. Same doors. Everywhere on Earth.",
    "text": "",
    "sec": 8,
    "img": "e1-the-box-03.jpg"
   },
   {
    "id": "1D",
    "size": "CU",
    "angle": "low",
    "move": "static",
    "action": "A single corner casting, rust in the seams.",
    "vo": "That is not how the world usually works. So who decided?",
    "text": "",
    "sec": 7,
    "img": "e1-the-box-04.jpg"
   },
   {
    "id": "2A",
    "size": "WS",
    "angle": "eye",
    "move": "static",
    "action": "1950s American highway, trucks.",
    "vo": "In nineteen fifty six, the man about to answer that was not in shipping.",
    "text": "1956",
    "sec": 8,
    "img": "e1-the-box-05.jpg"
   },
   {
    "id": "2B",
    "size": "MS",
    "angle": "eye",
    "move": "slow push",
    "action": "Truck cab interior, hands on wheel.",
    "vo": "Malcolm McLean owned lorries. Which is exactly why he could see it.",
    "text": "",
    "sec": 9,
    "img": "e1-the-box-06.jpg"
   },
   {
    "id": "2C",
    "size": "WS",
    "angle": "high",
    "move": "static",
    "action": "Dock, cargo nets, men working.",
    "vo": "Because if you owned lorries, you spent your life watching them wait.",
    "text": "",
    "sec": 8,
    "img": "e1-the-box-07.jpg"
   },
   {
    "id": "2D",
    "size": "MS",
    "angle": "eye",
    "move": "static",
    "action": "Men carrying sacks up a gangway.",
    "vo": "Loading a ship meant men carrying things aboard. One thing at a time.",
    "text": "",
    "sec": 9,
    "img": "e1-the-box-08.jpg"
   },
   {
    "id": "2E",
    "size": "CU",
    "angle": "low",
    "move": "tilt",
    "action": "Stopwatch or clock face.",
    "vo": "It could take longer to load a ship than to sail it across an ocean.",
    "text": "LONGER TO LOAD",
    "sec": 8,
    "img": "e1-the-box-09.jpg"
   },
   {
    "id": "3A",
    "size": "WS",
    "angle": "eye",
    "move": "static",
    "action": "Ship at dock, empty deck.",
    "vo": "The obvious fix is a box. Everybody had already thought of the box.",
    "text": "",
    "sec": 8,
    "img": "e1-the-box-10.jpg"
   },
   {
    "id": "3B",
    "size": "MS",
    "angle": "eye",
    "move": "pan",
    "action": "Assorted crates, different sizes.",
    "vo": "Companies had boxes. The trouble was that everyone had a different one.",
    "text": "",
    "sec": 9,
    "img": "e1-the-box-11.jpg"
   },
   {
    "id": "3C",
    "size": "CU",
    "angle": "eye",
    "move": "static",
    "action": "Mismatched fittings, a bad join.",
    "vo": "A box that fits your crane and nobody else's is just an expensive crate.",
    "text": "",
    "sec": 8,
    "img": "e1-the-box-12.jpg"
   },
   {
    "id": "4A",
    "size": "WS",
    "angle": "high",
    "move": "slow push",
    "action": "Converted tanker at sea.",
    "vo": "On the twenty sixth of April, a converted oil tanker left Newark for Houston.",
    "text": "26 APRIL 1956",
    "sec": 9,
    "img": "e1-the-box-13.jpg"
   },
   {
    "id": "4B",
    "size": "MS",
    "angle": "eye",
    "move": "static",
    "action": "Boxes on deck, ordered rows.",
    "vo": "Fifty eight boxes. No cargo nets. No queue of men.",
    "text": "58 BOXES",
    "sec": 8,
    "img": "e1-the-box-14.jpg"
   },
   {
    "id": "4C",
    "size": "CU",
    "angle": "eye",
    "move": "static",
    "action": "Ledger or invoice, figures.",
    "vo": "Loading cost had been about six dollars a ton. It fell to about sixteen cents.",
    "text": "$5.86 \u2192 $0.16",
    "sec": 10,
    "img": "e1-the-box-15.jpg"
   },
   {
    "id": "4D",
    "size": "WS",
    "angle": "eye",
    "move": "static",
    "action": "Modern port, cranes at speed.",
    "vo": "That is not an improvement. That is a different planet.",
    "text": "",
    "sec": 8,
    "img": "e1-the-box-16.jpg"
   },
   {
    "id": "5A",
    "size": "MS",
    "angle": "eye",
    "move": "static",
    "action": "Drawing board, technical plan.",
    "vo": "And here is where the story stops being about a box.",
    "text": "",
    "sec": 7,
    "img": "e1-the-box-17.jpg"
   },
   {
    "id": "5B",
    "size": "CU",
    "angle": "eye",
    "move": "slow push",
    "action": "Patent document, stamp.",
    "vo": "McLean held the patents. He could have licensed them to every port on Earth.",
    "text": "",
    "sec": 9,
    "img": "e1-the-box-18.jpg"
   },
   {
    "id": "5C",
    "size": "MS",
    "angle": "eye",
    "move": "static",
    "action": "Meeting room, chairs, no people.",
    "vo": "Instead he handed them to the standards body. Royalty free.",
    "text": "ROYALTY FREE",
    "sec": 9,
    "img": "e1-the-box-19.jpg"
   },
   {
    "id": "5D",
    "size": "CU",
    "angle": "low",
    "move": "static",
    "action": "Container door lock, precise engineering.",
    "vo": "Ten feet. Twenty feet. Forty feet. Eight feet wide. Agreed by everyone.",
    "text": "",
    "sec": 9,
    "img": "e1-the-box-20.jpg"
   },
   {
    "id": "6A",
    "size": "WS",
    "angle": "high",
    "move": "static",
    "action": "Global port at dusk, enormous.",
    "vo": "Because a standard only works if nobody owns it.",
    "text": "",
    "sec": 9,
    "img": "e1-the-box-21.jpg"
   },
   {
    "id": "6B",
    "size": "MS",
    "angle": "eye",
    "move": "pan",
    "action": "Supermarket shelves, full.",
    "vo": "Everything cheap in your house is downstream of that decision.",
    "text": "",
    "sec": 9,
    "img": "e1-the-box-22.jpg"
   },
   {
    "id": "6C",
    "size": "CU",
    "angle": "eye",
    "move": "static",
    "action": "A single container door, closed.",
    "vo": "He could have owned the box.",
    "text": "",
    "sec": 6,
    "img": "e1-the-box-23.jpg"
   },
   {
    "id": "6D",
    "size": "WS",
    "angle": "eye",
    "move": "slow pull",
    "action": "Container ship passing a city skyline.",
    "vo": "Instead he owned the world the box built.",
    "text": "",
    "sec": 10,
    "img": "e1-the-box-24.jpg"
   }
  ]
 },
 {
  "slug": "e2-cheap-food",
  "title": "EP2 \u00b7 CHEAP FOOD \u2014 somebody else is paying",
  "shots": [
   {
    "id": "1A",
    "size": "CU",
    "angle": "eye",
    "move": "slow push",
    "action": "Supermarket price label, unremarkable.",
    "vo": "A chicken costs less today than it did in nineteen sixty.",
    "text": "",
    "sec": 8,
    "img": "e2-cheap-food-01.jpg"
   },
   {
    "id": "1B",
    "size": "WS",
    "angle": "eye",
    "move": "pan",
    "action": "Full supermarket aisle, abundance.",
    "vo": "Not less relative to wages. Less. In actual money.",
    "text": "",
    "sec": 8,
    "img": "e2-cheap-food-02.jpg"
   },
   {
    "id": "1C",
    "size": "MS",
    "angle": "eye",
    "move": "static",
    "action": "Trolley being filled.",
    "vo": "Nothing else in your life has done that. Not rent, not petrol, not a haircut.",
    "text": "",
    "sec": 9,
    "img": "e2-cheap-food-03.jpg"
   },
   {
    "id": "1D",
    "size": "CU",
    "angle": "low",
    "move": "static",
    "action": "Coins on a counter.",
    "vo": "So either farming got miraculous, or somebody else is paying.",
    "text": "",
    "sec": 8,
    "img": "e2-cheap-food-04.jpg"
   },
   {
    "id": "2A",
    "size": "WS",
    "angle": "high",
    "move": "static",
    "action": "Vast monoculture field.",
    "vo": "Farming did get miraculous. That part is true.",
    "text": "",
    "sec": 8,
    "img": "e2-cheap-food-05.jpg"
   },
   {
    "id": "2B",
    "size": "MS",
    "angle": "eye",
    "move": "tracking",
    "action": "Combine harvester working.",
    "vo": "One machine now does the work of five hundred people.",
    "text": "500 PEOPLE",
    "sec": 9,
    "img": "e2-cheap-food-06.jpg"
   },
   {
    "id": "2C",
    "size": "CU",
    "angle": "eye",
    "move": "static",
    "action": "Fertiliser granules in a hand.",
    "vo": "And we learned to make fertiliser out of air and gas.",
    "text": "",
    "sec": 8,
    "img": "e2-cheap-food-07.jpg"
   },
   {
    "id": "2D",
    "size": "WS",
    "angle": "eye",
    "move": "static",
    "action": "Industrial glasshouse, endless rows.",
    "vo": "Yields tripled. Genuinely one of the great achievements.",
    "text": "",
    "sec": 8,
    "img": "e2-cheap-food-08.jpg"
   },
   {
    "id": "3A",
    "size": "MS",
    "angle": "eye",
    "move": "slow push",
    "action": "Empty government building corridor.",
    "vo": "Now the part that is not on the label.",
    "text": "",
    "sec": 7,
    "img": "e2-cheap-food-09.jpg"
   },
   {
    "id": "3B",
    "size": "CU",
    "angle": "eye",
    "move": "static",
    "action": "Stack of official documents.",
    "vo": "Rich countries pay their farmers hundreds of billions a year.",
    "text": "",
    "sec": 9,
    "img": "e2-cheap-food-10.jpg"
   },
   {
    "id": "3C",
    "size": "WS",
    "angle": "eye",
    "move": "static",
    "action": "Tractor at rest, evening.",
    "vo": "Not as charity. As a decision that food should feel cheap.",
    "text": "",
    "sec": 9,
    "img": "e2-cheap-food-11.jpg"
   },
   {
    "id": "3D",
    "size": "CU",
    "angle": "low",
    "move": "static",
    "action": "A receipt, close.",
    "vo": "You already paid. It just was not at the till.",
    "text": "NOT AT THE TILL",
    "sec": 8,
    "img": "e2-cheap-food-12.jpg"
   },
   {
    "id": "4A",
    "size": "WS",
    "angle": "high",
    "move": "static",
    "action": "Eroded, cracked soil.",
    "vo": "There is a second bill, and this one is not in money.",
    "text": "",
    "sec": 8,
    "img": "e2-cheap-food-13.jpg"
   },
   {
    "id": "4B",
    "size": "MS",
    "angle": "eye",
    "move": "pan",
    "action": "Irrigation across dry land.",
    "vo": "We are spending soil and water faster than they come back.",
    "text": "",
    "sec": 9,
    "img": "e2-cheap-food-14.jpg"
   },
   {
    "id": "4C",
    "size": "CU",
    "angle": "eye",
    "move": "static",
    "action": "Water pipe running.",
    "vo": "An aquifer that took ten thousand years to fill can be emptied in fifty.",
    "text": "10,000 YEARS \u2192 50",
    "sec": 10,
    "img": "e2-cheap-food-15.jpg"
   },
   {
    "id": "4D",
    "size": "WS",
    "angle": "eye",
    "move": "static",
    "action": "Dust blowing over a field.",
    "vo": "That is not farming. That is drawing down capital and calling it income.",
    "text": "",
    "sec": 9,
    "img": "e2-cheap-food-16.jpg"
   },
   {
    "id": "5A",
    "size": "MS",
    "angle": "eye",
    "move": "static",
    "action": "Loading bay, crates moving.",
    "vo": "And a third bill, paid by whoever is furthest from you.",
    "text": "",
    "sec": 8,
    "img": "e2-cheap-food-17.jpg"
   },
   {
    "id": "5B",
    "size": "WS",
    "angle": "eye",
    "move": "static",
    "action": "Workers in a field at distance.",
    "vo": "The cheaper the shelf price, the further down the chain the squeeze goes.",
    "text": "",
    "sec": 9,
    "img": "e2-cheap-food-18.jpg"
   },
   {
    "id": "5C",
    "size": "CU",
    "angle": "eye",
    "move": "static",
    "action": "Hands sorting produce.",
    "vo": "Somebody is always absorbing it. It is simply never the person shopping.",
    "text": "",
    "sec": 9,
    "img": "e2-cheap-food-19.jpg"
   },
   {
    "id": "6A",
    "size": "WS",
    "angle": "eye",
    "move": "slow pull",
    "action": "Supermarket at night, lit, empty.",
    "vo": "None of this means cheap food was a mistake.",
    "text": "",
    "sec": 8,
    "img": "e2-cheap-food-20.jpg"
   },
   {
    "id": "6B",
    "size": "MS",
    "angle": "eye",
    "move": "static",
    "action": "Family meal on a table.",
    "vo": "It fed billions of people and that is not nothing.",
    "text": "",
    "sec": 8,
    "img": "e2-cheap-food-21.jpg"
   },
   {
    "id": "6C",
    "size": "CU",
    "angle": "eye",
    "move": "slow push",
    "action": "A single price tag again.",
    "vo": "But a price is not a fact. It is a decision about who pays.",
    "text": "",
    "sec": 9,
    "img": "e2-cheap-food-22.jpg"
   },
   {
    "id": "6D",
    "size": "WS",
    "angle": "high",
    "move": "static",
    "action": "Fields to the horizon at dusk.",
    "vo": "And most of the people paying never see the receipt.",
    "text": "",
    "sec": 10,
    "img": "e2-cheap-food-23.jpg"
   }
  ]
 },
 {
  "slug": "e3-three-companies",
  "title": "EP3 \u00b7 THE THREE \u2014 who decides what you hear",
  "shots": [
   {
    "id": "1A",
    "size": "CU",
    "angle": "eye",
    "move": "slow push",
    "action": "Phone screen, a playlist.",
    "vo": "Think of a song you have loved this year.",
    "text": "",
    "sec": 7,
    "img": "e3-three-companies-01.jpg"
   },
   {
    "id": "1B",
    "size": "MS",
    "angle": "eye",
    "move": "static",
    "action": "Headphones on a desk.",
    "vo": "There is about a three in four chance it belongs to one of three companies.",
    "text": "3 IN 4",
    "sec": 9,
    "img": "e3-three-companies-02.jpg"
   },
   {
    "id": "1C",
    "size": "WS",
    "angle": "eye",
    "move": "pan",
    "action": "Recording studio, empty.",
    "vo": "Not three genres. Not three countries. Three companies.",
    "text": "",
    "sec": 8,
    "img": "e3-three-companies-03.jpg"
   },
   {
    "id": "1D",
    "size": "CU",
    "angle": "low",
    "move": "static",
    "action": "Mixing desk faders.",
    "vo": "Nobody voted for that, and almost nobody noticed it happening.",
    "text": "",
    "sec": 8,
    "img": "e3-three-companies-04.jpg"
   },
   {
    "id": "2A",
    "size": "WS",
    "angle": "eye",
    "move": "static",
    "action": "Old record shop interior.",
    "vo": "In the eighties there were six majors. Then five. Then four.",
    "text": "6 \u2192 5 \u2192 4 \u2192 3",
    "sec": 9,
    "img": "e3-three-companies-05.jpg"
   },
   {
    "id": "2B",
    "size": "MS",
    "angle": "eye",
    "move": "static",
    "action": "Boxes of vinyl records.",
    "vo": "Each merger looked sensible on its own.",
    "text": "",
    "sec": 8,
    "img": "e3-three-companies-06.jpg"
   },
   {
    "id": "2C",
    "size": "CU",
    "angle": "eye",
    "move": "static",
    "action": "Contract pages.",
    "vo": "That is how consolidation always looks. Sensible, one step at a time.",
    "text": "",
    "sec": 9,
    "img": "e3-three-companies-07.jpg"
   },
   {
    "id": "2D",
    "size": "WS",
    "angle": "high",
    "move": "static",
    "action": "Corporate tower, glass.",
    "vo": "Nobody sets out to build an oligopoly. They just keep buying.",
    "text": "",
    "sec": 8,
    "img": "e3-three-companies-08.jpg"
   },
   {
    "id": "3A",
    "size": "MS",
    "angle": "eye",
    "move": "slow push",
    "action": "Server racks, blinking.",
    "vo": "Then streaming arrived, and everyone assumed it would break the majors.",
    "text": "",
    "sec": 9,
    "img": "e3-three-companies-09.jpg"
   },
   {
    "id": "3B",
    "size": "CU",
    "angle": "eye",
    "move": "static",
    "action": "Play button on a screen.",
    "vo": "Anyone can upload. No shelf space. No pressing plant.",
    "text": "",
    "sec": 8,
    "img": "e3-three-companies-10.jpg"
   },
   {
    "id": "3C",
    "size": "WS",
    "angle": "eye",
    "move": "static",
    "action": "Empty concert venue.",
    "vo": "It did the opposite.",
    "text": "",
    "sec": 7,
    "img": "e3-three-companies-11.jpg"
   },
   {
    "id": "3D",
    "size": "MS",
    "angle": "eye",
    "move": "static",
    "action": "Analytics dashboard.",
    "vo": "Because when everything is available, the scarce thing is attention.",
    "text": "",
    "sec": 9,
    "img": "e3-three-companies-12.jpg"
   },
   {
    "id": "4A",
    "size": "CU",
    "angle": "eye",
    "move": "static",
    "action": "Playlist rows on a screen.",
    "vo": "And attention is allocated by playlists.",
    "text": "",
    "sec": 8,
    "img": "e3-three-companies-13.jpg"
   },
   {
    "id": "4B",
    "size": "MS",
    "angle": "eye",
    "move": "pan",
    "action": "Office desks, people working.",
    "vo": "Which are made by people, who take meetings, with the people who own the catalogue.",
    "text": "",
    "sec": 10,
    "img": "e3-three-companies-14.jpg"
   },
   {
    "id": "4C",
    "size": "CU",
    "angle": "low",
    "move": "static",
    "action": "Handshake, cropped at the wrists.",
    "vo": "The majors did not need the shelf. They needed the algorithm to like them.",
    "text": "",
    "sec": 9,
    "img": "e3-three-companies-15.jpg"
   },
   {
    "id": "4D",
    "size": "WS",
    "angle": "eye",
    "move": "static",
    "action": "Stage lights, no performer.",
    "vo": "And it does.",
    "text": "",
    "sec": 6,
    "img": "e3-three-companies-16.jpg"
   },
   {
    "id": "5A",
    "size": "MS",
    "angle": "eye",
    "move": "static",
    "action": "Musician packing a guitar.",
    "vo": "For an artist the maths is brutal and boring.",
    "text": "",
    "sec": 8,
    "img": "e3-three-companies-17.jpg"
   },
   {
    "id": "5B",
    "size": "CU",
    "angle": "eye",
    "move": "static",
    "action": "Calculator and paperwork.",
    "vo": "A million plays is a few thousand pounds, split several ways.",
    "text": "",
    "sec": 9,
    "img": "e3-three-companies-18.jpg"
   },
   {
    "id": "5C",
    "size": "WS",
    "angle": "eye",
    "move": "static",
    "action": "Small venue, few people.",
    "vo": "Which is why touring stopped being promotion and became the job.",
    "text": "",
    "sec": 9,
    "img": "e3-three-companies-19.jpg"
   },
   {
    "id": "6A",
    "size": "MS",
    "angle": "eye",
    "move": "slow push",
    "action": "Someone listening, eyes closed.",
    "vo": "You are not being cheated. You are being catalogued.",
    "text": "",
    "sec": 8,
    "img": "e3-three-companies-20.jpg"
   },
   {
    "id": "6B",
    "size": "CU",
    "angle": "eye",
    "move": "static",
    "action": "Skip button.",
    "vo": "Every skip is a vote in an election you did not know you entered.",
    "text": "",
    "sec": 9,
    "img": "e3-three-companies-21.jpg"
   },
   {
    "id": "6C",
    "size": "WS",
    "angle": "eye",
    "move": "static",
    "action": "City at night, lights.",
    "vo": "Three companies count the votes.",
    "text": "",
    "sec": 8,
    "img": "e3-three-companies-22.jpg"
   },
   {
    "id": "6D",
    "size": "CU",
    "angle": "eye",
    "move": "slow pull",
    "action": "Phone face down on a table.",
    "vo": "And the winner is whatever keeps you from reaching for the phone.",
    "text": "",
    "sec": 9,
    "img": "e3-three-companies-23.jpg"
   }
  ]
 },
 {
  "slug": "e4-built-to-die",
  "title": "EP4 \u00b7 BUILT TO DIE \u2014 the meeting that shortened everything",
  "shots": [
   {
    "id": "1A",
    "size": "CU",
    "angle": "eye",
    "move": "slow push",
    "action": "A dead lightbulb in a hand.",
    "vo": "In nineteen twenty four, a lightbulb could last two thousand five hundred hours.",
    "text": "2,500 HOURS",
    "sec": 9,
    "img": "e4-built-to-die-01.jpg"
   },
   {
    "id": "1B",
    "size": "MS",
    "angle": "eye",
    "move": "static",
    "action": "Row of bulbs hanging.",
    "vo": "By nineteen twenty five, that was a problem worth solving.",
    "text": "",
    "sec": 8,
    "img": "e4-built-to-die-02.jpg"
   },
   {
    "id": "1C",
    "size": "WS",
    "angle": "eye",
    "move": "static",
    "action": "Empty boardroom, long table.",
    "vo": "So the largest manufacturers in the world met, and solved it.",
    "text": "",
    "sec": 9,
    "img": "e4-built-to-die-03.jpg"
   },
   {
    "id": "1D",
    "size": "CU",
    "angle": "low",
    "move": "static",
    "action": "A signature on paper.",
    "vo": "They agreed to make bulbs worse.",
    "text": "MAKE IT WORSE",
    "sec": 8,
    "img": "e4-built-to-die-04.jpg"
   },
   {
    "id": "2A",
    "size": "MS",
    "angle": "eye",
    "move": "static",
    "action": "Old factory floor machinery.",
    "vo": "The target was one thousand hours. Not a maximum. A requirement.",
    "text": "1,000 HOURS",
    "sec": 9,
    "img": "e4-built-to-die-05.jpg"
   },
   {
    "id": "2B",
    "size": "CU",
    "angle": "eye",
    "move": "static",
    "action": "Filament close up.",
    "vo": "Members who overshot it were fined. There was a scale of fines.",
    "text": "",
    "sec": 9,
    "img": "e4-built-to-die-06.jpg"
   },
   {
    "id": "2C",
    "size": "WS",
    "angle": "high",
    "move": "static",
    "action": "Warehouse of stock.",
    "vo": "This is not a conspiracy theory. The paperwork survives.",
    "text": "",
    "sec": 8,
    "img": "e4-built-to-die-07.jpg"
   },
   {
    "id": "2D",
    "size": "MS",
    "angle": "eye",
    "move": "static",
    "action": "Filing cabinets.",
    "vo": "It has a name, the Phoebus cartel, and it ran for years.",
    "text": "PHOEBUS, 1925",
    "sec": 9,
    "img": "e4-built-to-die-08.jpg"
   },
   {
    "id": "3A",
    "size": "CU",
    "angle": "eye",
    "move": "slow push",
    "action": "Modern phone, cracked screen.",
    "vo": "Now the uncomfortable part.",
    "text": "",
    "sec": 7,
    "img": "e4-built-to-die-09.jpg"
   },
   {
    "id": "3B",
    "size": "MS",
    "angle": "eye",
    "move": "static",
    "action": "Repair bench, tools, opened device.",
    "vo": "Almost nothing today needs a cartel to die young.",
    "text": "",
    "sec": 9,
    "img": "e4-built-to-die-10.jpg"
   },
   {
    "id": "3C",
    "size": "CU",
    "angle": "eye",
    "move": "static",
    "action": "Glued seam on a device.",
    "vo": "A glued seam does it. A battery you cannot reach does it.",
    "text": "",
    "sec": 9,
    "img": "e4-built-to-die-11.jpg"
   },
   {
    "id": "3D",
    "size": "WS",
    "angle": "eye",
    "move": "static",
    "action": "Pile of discarded electronics.",
    "vo": "No meeting required. No minutes to leak.",
    "text": "",
    "sec": 8,
    "img": "e4-built-to-die-12.jpg"
   },
   {
    "id": "4A",
    "size": "MS",
    "angle": "eye",
    "move": "static",
    "action": "Software update screen.",
    "vo": "And the newest version does not need hardware at all.",
    "text": "",
    "sec": 8,
    "img": "e4-built-to-die-13.jpg"
   },
   {
    "id": "4B",
    "size": "CU",
    "angle": "eye",
    "move": "static",
    "action": "Spinning loading indicator.",
    "vo": "A product can simply become slower until you replace it.",
    "text": "",
    "sec": 9,
    "img": "e4-built-to-die-14.jpg"
   },
   {
    "id": "4C",
    "size": "WS",
    "angle": "eye",
    "move": "pan",
    "action": "Shelves of new devices in a shop.",
    "vo": "The old machine still works. It has just been left behind on purpose.",
    "text": "",
    "sec": 9,
    "img": "e4-built-to-die-15.jpg"
   },
   {
    "id": "5A",
    "size": "MS",
    "angle": "eye",
    "move": "static",
    "action": "Repair shop, someone working.",
    "vo": "There is a counter-movement, and it is winning slowly.",
    "text": "",
    "sec": 8,
    "img": "e4-built-to-die-16.jpg"
   },
   {
    "id": "5B",
    "size": "CU",
    "angle": "eye",
    "move": "static",
    "action": "Screwdriver on a screw.",
    "vo": "Right to repair laws. Spare parts requirements. Scored repairability.",
    "text": "",
    "sec": 9,
    "img": "e4-built-to-die-17.jpg"
   },
   {
    "id": "5C",
    "size": "WS",
    "angle": "eye",
    "move": "static",
    "action": "Refurbished devices on a rack.",
    "vo": "Which tells you the short life was never a law of physics.",
    "text": "",
    "sec": 9,
    "img": "e4-built-to-die-18.jpg"
   },
   {
    "id": "6A",
    "size": "CU",
    "angle": "eye",
    "move": "slow push",
    "action": "An old tool, clearly ancient, still working.",
    "vo": "Your grandmother's tools still work because nobody had decided yet that they should not.",
    "text": "",
    "sec": 10,
    "img": "e4-built-to-die-19.jpg"
   },
   {
    "id": "6B",
    "size": "MS",
    "angle": "eye",
    "move": "static",
    "action": "A modern appliance, sealed.",
    "vo": "Durability did not become impossible. It became unprofitable.",
    "text": "UNPROFITABLE",
    "sec": 9,
    "img": "e4-built-to-die-20.jpg"
   },
   {
    "id": "6C",
    "size": "WS",
    "angle": "high",
    "move": "static",
    "action": "Landfill or e-waste yard.",
    "vo": "And the bill for that arrives somewhere else.",
    "text": "",
    "sec": 9,
    "img": "e4-built-to-die-21.jpg"
   },
   {
    "id": "6D",
    "size": "CU",
    "angle": "eye",
    "move": "slow pull",
    "action": "A single working bulb, warm.",
    "vo": "In nineteen twenty five they had to hold a meeting. Now it is just how things are made.",
    "text": "",
    "sec": 10,
    "img": "e4-built-to-die-22.jpg"
   }
  ]
 }
];
